import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React from "react";

export interface IToggleButtonOption {
    id: string;
    title: string;
}

interface IToggleButtonsProps {
    value: string;
    options: IToggleButtonOption[];
    margin?: string | number;
    onChange: (id: string) => void;
}

export const ToggleButtons = (props: IToggleButtonsProps) => {
    const handleChange = (_: React.MouseEvent<HTMLElement, MouseEvent>, value: any) => {
        if (value === null) return;
        props.onChange(value);
    };

    return (
        <ToggleButtonGroup
            color="primary"
            value={props.value}
            exclusive
            fullWidth
            size="small"
            onChange={handleChange}
            sx={{ margin: props.margin }}
        >
            {props.options.map(i =>
                <ToggleButton key={i.id} value={i.id}>{i.title}</ToggleButton>
            )}
        </ToggleButtonGroup>
    );
};
